import _ from 'lodash'
import Base from '@/resources/Base'
import { DetectionRiskLevelScoreEnum } from '@/constants/risk-level.constants'
import { EnableDisableEnum } from '@/constants/on-off.constants'
import { MITRE_TACTIC_URL, MITRE_TECHNIQUE_URL } from '@/constants/attack-chain.constants'
import { buildAttackChainCommand } from '@/utilities/attack-chain.helper'

export default class Rule extends Base {
  constructor (uuid = null, attributes = {}, options = {}) {
    super(uuid, attributes, options)
    this.setEnabledBoolean(this.enabled)
    this.setEnabledText(this.enabled)
    this.setRuleScore(this.score)
    this.setExternalTacticUrlById(this.tactic)
    this.setExternalTechniqueUrlById(this.technique)
  }

  /**
   *
   * Set Rule Score base on severity level.
   */
  setEnabledBoolean (status) {
    if (_.isString(status)) {
      if (status === 'true') {
        this.enabled = true
      } else {
        this.enabled = false
      }
    } else {
      this.enabled = status
    }
  }

  setEnabledText (status) {
    if (status) {
      this.enabledText = EnableDisableEnum.properties.enable.title
    } else {
      this.enabledText = EnableDisableEnum.properties.disable.title
    }
  }

  /**
   *
   * Set Rule Score base on severity level.
   */
  setRuleScore (severity) {
    this.ruleScore = DetectionRiskLevelScoreEnum[severity]
  }

  /**
   *
   * Set External URL to Mitre technique.
   */
  setTactic (attackTactic) {
    if (attackTactic) {
      this.mitreAttackTactic = attackTactic
      this.displayTactic = `${this.tactic}: ${this.mitreAttackTactic.name}`
      this.configureKillChainFormat(this.mitreAttackTactic.name)
    }
  }

  /**
   *
   * Set External URL to Mitre technique.
   */
  setTechnique (attackTechnique) {
    if (attackTechnique) {
      this.mitreAttackTechnique = attackTechnique
    }
  }

  /**
   *
   * Set External URL to Mitre technique.
   */
  setExternalTacticUrl (mitreTacticUrl) {
    if (!mitreTacticUrl) {
      return false
    }
    this.externalTacticUrl = mitreTacticUrl
  }

  /**
   *
   * Set External URL to Mitre technique.
   */
  setExternalTechniqueUrl (mitreTechniqueUrl) {
    if (!mitreTechniqueUrl) {
      return false
    }
    this.externalTechniqueUrl = mitreTechniqueUrl
  }

  /**
   *
   * Set External URL to Mitre technique.
   */
  setExternalTacticUrlById (tacticId) {
    if (!tacticId) {
      return false
    }
    this.externalTacticUrl = `${MITRE_TACTIC_URL}${tacticId.replace('.', '/')}`
  }

  /**
   *
   * Set External URL to Mitre technique.
   */
  setExternalTechniqueUrlById (techniqueId) {
    if (!techniqueId) {
      return false
    }
    this.externalTechniqueUrl = `${MITRE_TECHNIQUE_URL}${techniqueId.replace('.', '/')}`
  }

  /**
   *
   * Configure kill chain chart settings and kill chain segment blocks.
   */
  configureKillChainFormat (category) {
    let chains = buildAttackChainCommand([category.toUpperCase().replace(/ /g, '_')])
    this.killChainData = {
      datasets: [
        {
          data: chains['data'],
          backgroundColor: chains['backgroundColor']
        }
      ],
      labels: chains['labels']
    }
  }
}



// WEBPACK FOOTER //
// ./src/resources/models/Rule.js